import {fetchDataFromApi} from './apiHelper';

export const fetchFullRevenueTotals = () => fetchDataFromApi('post', '/api/charts/revenue/fulltotals');
export const fetchQpsDaily = () => fetchDataFromApi('post', '/api/charts/qps-daily');
export const fetchQpsWasteful = () => fetchDataFromApi('post', '/api/charts/qps-wasteful');
export const fetchBundlesBy = () => fetchDataFromApi('post', '/api/charts/bundles/by');